(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bloup-compare"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var btns = root.querySelectorAll('[data-bcx-go]');
    var stage = root.querySelector('[data-bcx-stage]');
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function set(mode) {
      if (root.dataset.mode === mode) return;
      root.dataset.mode = mode;
      btns.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.bcxGo === mode ? 'true' : 'false'); });
      root.querySelectorAll('.bcx-val--old').forEach(function (e) { e.setAttribute('aria-hidden', mode === 'new'); });
      root.querySelectorAll('.bcx-val--new').forEach(function (e) { e.setAttribute('aria-hidden', mode === 'old'); });
      root.classList.remove('is-pop');
      if (mode === 'new' && !still) { void root.offsetWidth; root.classList.add('is-pop'); }
    }
    root.querySelectorAll('.bcx-val--new').forEach(function (e) { e.setAttribute('aria-hidden', 'true'); });
    btns.forEach(function (b) { b.addEventListener('click', function () { root.classList.add('is-touched'); set(b.dataset.bcxGo); }); });
    stage.addEventListener('click', function () { root.classList.add('is-touched'); set(root.dataset.mode === 'old' ? 'new' : 'old'); });
    var x0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) { root.classList.add('is-touched'); set(dx < 0 ? 'new' : 'old'); }
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) {
            io.disconnect();
            setTimeout(function () { if (!root.classList.contains('is-touched')) set('new'); }, still ? 0 : 2200);
          }
        });
      }, { threshold: .55 });
      io.observe(stage);
    }
  }
  function init() { document.querySelectorAll('[data-bcx]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloup-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var items = Array.prototype.slice.call(root.querySelectorAll('.blq__item'));
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open || still) return;
        d.classList.add('is-typing');
        clearTimeout(d._blq);
        d._blq = setTimeout(function () { d.classList.remove('is-typing'); }, 650);
      });
    });
    var chips = root.querySelectorAll('[data-blq-topic]');
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var t = c.dataset.blqTopic;
        chips.forEach(function (o) { o.setAttribute('aria-pressed', o === c ? 'true' : 'false'); });
        items.forEach(function (d) {
          var show = !t || d.dataset.topic === t;
          d.hidden = !show;
          if (!show) d.open = false;
        });
      });
    });
  }
  function init() { document.querySelectorAll('[data-blq]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloup-hero-cast"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var words = root.querySelectorAll('.ha-word');
    var slides = root.querySelectorAll('.ha-slide');
    var dots = root.querySelectorAll('.ha-dot');
    var card = root.querySelector('[data-ha-card]');
    var n = Math.min(words.length, slides.length);
    if (n < 2) return;
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var i = 0, timer = null, BASE = 2400;
    function show(j) {
      if (j === i) return;
      var w = words[i];
      w.classList.remove('is-on'); w.classList.add('is-out');
      setTimeout(function () { w.classList.remove('is-out'); }, 450);
      words[j].classList.add('is-on');
      dots[i] && dots[i].classList.remove('is-on');
      dots[j] && dots[j].classList.add('is-on');
      var prev = i; i = j;
      if (still) { slides[prev].classList.remove('is-on'); slides[j].classList.add('is-on'); return; }
      card.classList.add('is-flip');
      setTimeout(function () {
        slides[prev].classList.remove('is-on'); slides[j].classList.add('is-on');
        card.classList.remove('is-flip');
      }, 260);
    }
    function next() {
      show((i + 1) % n);
      schedule();
    }
    function schedule() {
      clearTimeout(timer);
      if (still) return;
      timer = setTimeout(next, BASE * (parseInt(slides[i].dataset.hold, 10) || 1));
    }
    dots.forEach(function (d, j) { d.addEventListener('click', function () { show(j); schedule(); }); });
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) schedule(); else clearTimeout(timer); });
    }) : null;
    if (io) io.observe(root); else schedule();
  }
  function init() { document.querySelectorAll('[data-ha]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloup-hero-drama"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var words = root.querySelectorAll('.hc-word');
    var stains = root.querySelectorAll('.hc-stain');
    var card = root.querySelector('[data-hc-card]');
    var art = root.querySelector('.hc-art');
    var trails = root.querySelector('.hc-trails');
    var n = Math.min(words.length, stains.length);
    if (!n || !card) return;
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var i = 0, t1 = null, busy = false, visible = false, rub = 0, last = null, rubTimer = null;
    var rot = root.querySelector('.hc-rot');
    function fit() { if (rot && words[i]) rot.style.width = words[i].offsetWidth + 'px'; }
    fit(); window.addEventListener('resize', fit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    function setDirt(v) { stains[i].style.setProperty('--o', v); }
    function clean(fromUser) {
      if (busy) return;
      busy = true; clearTimeout(t1);
      card.classList.add('is-clean'); art.classList.add('is-happy');
      if (fromUser && navigator.vibrate) { try { navigator.vibrate(18); } catch (e) {} }
      setTimeout(nextWord, 1900);
    }
    function nextWord() {
      card.classList.remove('is-clean'); art.classList.remove('is-happy');
      words[i].classList.remove('is-on'); stains[i].classList.remove('is-on'); setDirt(1);
      i = (i + 1) % n; rub = 0;
      words[i].classList.add('is-on'); stains[i].classList.add('is-on'); setDirt(1);
      fit();
      busy = false;
      auto();
    }
    function auto() { clearTimeout(t1); if (visible && !still) t1 = setTimeout(function () { clean(false); }, 2200); }
    card.addEventListener('click', function () { clean(true); });
    card.addEventListener('pointermove', function (e) {
      if (busy) return;
      if (e.pointerType === 'mouse' && e.buttons === 0 && !card.matches(':hover')) return;
      var r = card.getBoundingClientRect();
      var x = e.clientX - r.left, y = e.clientY - r.top;
      if (last) {
        var d = Math.hypot(x - last.x, y - last.y);
        if (d < 14) return;
        rub += d;
      }
      last = { x: x, y: y };
      clearTimeout(t1);
      card.classList.add('is-rubbing');
      clearTimeout(rubTimer);
      rubTimer = setTimeout(function () { card.classList.remove('is-rubbing'); last = null; if (!busy) auto(); }, 900);
      if (!still && trails.childElementCount < 18) {
        var b = document.createElement('i');
        b.style.left = x + 'px'; b.style.top = y + 'px';
        b.style.setProperty('--s', (14 + Math.random() * 16).toFixed(0) + 'px');
        trails.appendChild(b);
        setTimeout(function () { b.remove(); }, 700);
      }
      setDirt(Math.max(0, 1 - rub / 320).toFixed(2));
      if (rub > 320) { card.classList.remove('is-rubbing'); clean(true); }
    });
    card.addEventListener('pointerleave', function () { last = null; });
    if (still) return;
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        visible = e.isIntersecting;
        root.classList.toggle('is-off', !visible);
        if (visible && !busy) auto(); else if (!visible) clearTimeout(t1);
      });
    }) : null;
    if (io) io.observe(root); else { visible = true; auto(); }
  }
  function init() { document.querySelectorAll('[data-hc]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloup-hero-grises"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var words = root.querySelectorAll('.hb-word');
    if (words.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i = 0;
    setInterval(function () {
      var cur = words[i];
      cur.classList.remove('is-on'); cur.classList.add('is-out');
      setTimeout(function () { cur.classList.remove('is-out'); }, 400);
      i = (i + 1) % words.length;
      words[i].classList.add('is-on');
    }, 2300);
  }
  function init() { document.querySelectorAll('[data-hb]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloup-home-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var words = root.querySelectorAll('.bh-word');
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (words.length > 1 && !still) {
      var i = 0;
      setInterval(function () {
        var cur = words[i];
        cur.classList.remove('is-on'); cur.classList.add('is-out');
        setTimeout(function () { cur.classList.remove('is-out'); }, 500);
        i = (i + 1) % words.length;
        words[i].classList.add('is-on');
      }, 2200);
    }
    var art = root.querySelector('[data-bh-tilt]');
    var card = art && art.querySelector('.bh-card');
    if (card && !still && window.matchMedia('(hover: hover)').matches) {
      art.addEventListener('mousemove', function (e) {
        var r = art.getBoundingClientRect();
        card.style.setProperty('--ry', (((e.clientX - r.left) / r.width - .5) * 16).toFixed(2) + 'deg');
        card.style.setProperty('--rx', (((e.clientY - r.top) / r.height - .5) * -16).toFixed(2) + 'deg');
      });
      art.addEventListener('mouseleave', function () { card.style.removeProperty('--rx'); card.style.removeProperty('--ry'); });
    }
  }
  function init() { document.querySelectorAll('[data-bh]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloup-home-picker"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-bp-go]'));
    var panels = root.querySelectorAll('[data-bp-panel]');
    var stage = root.querySelector('[data-bp-stage]');
    var cur = 0, timer = null, T = 5000;
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function go(i, user) {
      i = (i + chips.length) % chips.length;
      chips.forEach(function (c, j) { c.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
      panels.forEach(function (p, j) { p.hidden = j !== i; p.classList.toggle('is-on', j === i); });
      if (user) { root.classList.add('is-paused'); clearInterval(timer); timer = null; }
      var row = chips[i].parentNode;
      row.scrollTo({ left: chips[i].offsetLeft - row.clientWidth / 2 + chips[i].offsetWidth / 2, behavior: still ? 'auto' : 'smooth' });
      cur = i;
    }
    chips.forEach(function (c, i) { c.addEventListener('click', function () { go(i, true); }); });
    var x0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1), true);
    });
    if (!still && chips.length > 1 && 'IntersectionObserver' in window) {
      root.style.setProperty('--t', T + 'ms');
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting && !timer && !root.classList.contains('is-paused')) {
            timer = setInterval(function () { go(cur + 1, false); }, T);
          } else if (!e.isIntersecting && timer) { clearInterval(timer); timer = null; }
        });
      }, { threshold: .4 }).observe(root);
    } else { root.classList.add('is-paused'); }
  }
  function init() { document.querySelectorAll('[data-bp]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloup-home-spot"] && !Shopify.designMode) return;
  try {
    
(function () {
  function run(el) {
    var raw = el.dataset.bsNum, m = raw.match(/^(\D*)(\d+)(.*)$/);
    if (!m) return;
    var end = parseInt(m[2], 10), t0 = null;
    function step(t) {
      if (!t0) t0 = t;
      var k = Math.min(1, (t - t0) / 1100);
      el.textContent = m[1] + Math.round(end * (1 - Math.pow(1 - k, 3))) + m[3];
      if (k < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function setup(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { root.querySelectorAll('[data-bs-num]').forEach(run); io.disconnect(); } });
    }, { threshold: .4 });
    io.observe(root);
  }
  function init() { document.querySelectorAll('[data-bs]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloup-kids-mission"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-pk-step]'));
    var fill = root.querySelector('[data-pk-fill]');
    var count = root.querySelector('[data-pk-count]');
    var done = root.querySelector('[data-pk-done]');
    var again = root.querySelector('[data-pk-again]');
    function update() {
      var n = steps.filter(function (s) { return s.getAttribute('aria-pressed') === 'true'; }).length;
      fill.style.transform = 'scaleX(' + (steps.length ? n / steps.length : 0) + ')';
      count.textContent = n + '/' + steps.length;
      if (n === steps.length && steps.length) {
        setTimeout(function () { done.hidden = false; if (again) again.focus({ preventScroll: true }); }, 450);
        if (navigator.vibrate) { try { navigator.vibrate([12, 60, 12]); } catch (e) {} }
      }
    }
    steps.forEach(function (s) {
      s.addEventListener('click', function () {
        s.setAttribute('aria-pressed', s.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        update();
      });
    });
    if (again) again.addEventListener('click', function () {
      done.hidden = true;
      steps.forEach(function (s) { s.setAttribute('aria-pressed', 'false'); });
      update();
      if (steps[0]) steps[0].focus({ preventScroll: true });
    });
  }
  function init() { document.querySelectorAll('[data-pk]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloup-moments"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-blmo-step]'));
    var track = root.querySelector('[data-blmo-track]');
    var dots = root.querySelectorAll('[data-blmo-go]');
    /* Celular: puntos que siguen el deslizamiento */
    if (track && dots.length) {
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var max = track.scrollWidth - track.clientWidth;
          var i = max > 0 ? Math.round(track.scrollLeft / max * (steps.length - 1)) : 0;
          dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); });
        });
      }, { passive: true });
      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          var s = steps[Number(d.dataset.blmoGo)];
          if (s) track.scrollTo({ left: s.offsetLeft - track.offsetLeft - 16, behavior: 'smooth' });
        });
      });
    }
    /* Computador: la foto fija cambia al bajar */
    if (!window.matchMedia('(min-width: 990px)').matches || !('IntersectionObserver' in window)) return;
    var pics = root.querySelectorAll('[data-blmo-pic]');
    var bars = root.querySelectorAll('.blmo__bars span');
    var num = root.querySelector('[data-blmo-num]');
    var label = root.querySelector('[data-blmo-label]');
    var current = 0;
    function go(i) {
      if (i === current || !pics[i]) return;
      pics.forEach(function (p, j) { p.classList.remove('was-on'); if (j === current) p.classList.add('was-on'); p.classList.toggle('is-on', j === i); });
      bars.forEach(function (b, j) { b.classList.toggle('is-on', j === i); b.classList.toggle('is-done', j < i); });
      steps.forEach(function (s, j) { s.classList.toggle('is-on', j === i); });
      if (num) num.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
      if (label) label.textContent = steps[i].dataset.label || '';
      current = i;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) go(steps.indexOf(e.target)); });
    }, { rootMargin: '-60% 0px -30% 0px' });
    steps.forEach(function (s) { io.observe(s); });
  }
  function init() { document.querySelectorAll('[data-blmo]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloup-pick-cards"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var track = root.querySelector('[data-qc-track]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-qc-card]'));
    var hint = root.querySelector('[data-qc-hint]');
    var base = hint ? hint.textContent : '';
    var cur = 0;
    function mark() {
      var mid = track.scrollLeft + track.clientWidth / 2, best = 0, bd = 1e9;
      cards.forEach(function (c, i) { var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid); if (d < bd) { bd = d; best = i; } });
      cur = best;
      cards.forEach(function (c, i) { c.classList.toggle('is-on', i === best); });
      if (hint) hint.textContent = best === 0 ? base : (best + 1) + ' de ' + cards.length;
    }
    function go(i) {
      i = Math.max(0, Math.min(cards.length - 1, i));
      var c = cards[i];
      track.scrollTo({ left: c.offsetLeft - (track.clientWidth - c.offsetWidth) / 2, behavior: 'smooth' });
    }
    var t = null;
    track.addEventListener('scroll', function () { cancelAnimationFrame(t); t = requestAnimationFrame(mark); }, { passive: true });
    root.querySelector('[data-qc-prev]').addEventListener('click', function () { go(cur - 1); });
    root.querySelector('[data-qc-next]').addEventListener('click', function () { go(cur + 1); });
    window.addEventListener('resize', mark);
    mark();
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (e) { root.classList.toggle('is-off', !e.isIntersecting); }); }).observe(root);
  }
  function init() { document.querySelectorAll('[data-qc]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloup-pick-house"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var rooms = root.querySelectorAll('[data-qh-go]');
    var cards = root.querySelectorAll('[data-qh-card]');
    rooms.forEach(function (r, i) {
      r.addEventListener('click', function () {
        rooms.forEach(function (x, j) { x.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
        cards.forEach(function (c, j) { c.hidden = j !== i; });
      });
    });
  }
  function init() { document.querySelectorAll('[data-qh]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloup-plans-chat"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-pw-go]'));
    var threads = root.querySelectorAll('[data-pw-thread]');
    if (!threads.length) return;
    function show(i) {
      tabs.forEach(function (t, j) { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
      threads.forEach(function (th, j) { th.hidden = j !== i; th.classList.toggle('is-on', j === i); });
    }
    tabs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    /* La primera conversación se «escribe» cuando la sección entra en pantalla. */
    var first = threads[0];
    first.classList.remove('is-on');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        if (es[0].isIntersecting) { io.disconnect(); if (!first.hidden) first.classList.add('is-on'); }
      }, { threshold: .35 });
      io.observe(root.querySelector('.pw-chat'));
    } else { first.classList.add('is-on'); }
  }
  function init() { document.querySelectorAll('[data-pw]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloup-plans-chips"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-pa-go]'));
    var cards = root.querySelectorAll('[data-pa-card]');
    var cur = 0;
    function go(i) {
      i = (i + chips.length) % chips.length; cur = i;
      chips.forEach(function (c, j) { c.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
      cards.forEach(function (c, j) { c.hidden = j !== i; });
      var row = chips[i].parentNode;
      row.scrollTo({ left: chips[i].offsetLeft - row.clientWidth / 2 + chips[i].offsetWidth / 2, behavior: 'smooth' });
    }
    chips.forEach(function (c, i) { c.addEventListener('click', function () { go(i); }); });
    var stage = root.querySelector('.pa-stage'), x0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1)); });
  }
  function init() { document.querySelectorAll('[data-pa]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloup-plans-day"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var track = root.querySelector('[data-pb-track]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-pb-card]'));
    var sun = root.querySelector('[data-pb-sun]');
    if (!cards.length) return;
    var last = -1, raf = null;
    function mark() {
      var mid = track.scrollLeft + track.clientWidth / 2, best = 0, bd = 1e9;
      cards.forEach(function (c, i) { var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid); if (d < bd) { bd = d; best = i; } });
      if (best === last) return;
      last = best;
      cards.forEach(function (c, i) { c.classList.toggle('is-on', i === best); });
      var p = cards.length > 1 ? best / (cards.length - 1) : 0;
      sun.style.setProperty('--p', (p * 100).toFixed(1) + '%');
      sun.textContent = p < .7 ? '☀️' : '🌙';
      root.style.setProperty('--sky', 'color-mix(in srgb,' + cards[best].dataset.c + ' 30%,#fff)');
    }
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(mark); }, { passive: true });
    window.addEventListener('resize', function () { last = -1; mark(); });
    mark();
  }
  function init() { document.querySelectorAll('[data-pb]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloup-plans-dia"] && !Shopify.designMode) return;
  try {
    
(function () {
  function hours(t) {
    var m = /(\d{1,2})(?::(\d{2}))?\s*([ap])/i.exec(t || '');
    if (!m) return 12;
    var h = +m[1] % 12 + (+(m[2] || 0)) / 60;
    return m[3].toLowerCase() === 'p' ? h + 12 : h;
  }
  function setup(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var track = root.querySelector('[data-pd-track]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-pd-card]'));
    var skies = root.querySelectorAll('[data-pd-sky]');
    var dots = root.querySelectorAll('[data-pd-go]');
    var arm = root.querySelector('[data-pd-arm]');
    var orb = root.querySelector('[data-pd-orb]');
    var clock = root.querySelector('[data-pd-clock]');
    var where = root.querySelector('[data-pd-where]');
    if (!cards.length) return;
    var last = -1, raf = 0;
    function paint(i) {
      var h = hours(cards[i].dataset.time);
      var night = h >= 19 || h < 5.5;
      var phase = night ? 4 : h < 8 ? 0 : h < 12 ? 1 : h < 16 ? 2 : 3;
      var a = night ? -45 + Math.min(1, ((h < 5.5 ? h + 24 : h) - 19) / 7) * 100 : -55 + Math.min(1, Math.max(0, (h - 6) / 13)) * 115;
      skies.forEach(function (s, j) { s.classList.toggle('is-on', j === phase); });
      root.classList.toggle('is-night', night);
      root.style.setProperty('--a', a.toFixed(1) + 'deg');
      orb.textContent = night ? '🌙' : '☀️';
      clock.textContent = cards[i].dataset.time;
      where.textContent = cards[i].dataset.label;
    }
    function mark() {
      var mid = track.scrollLeft + track.clientWidth / 2, best = 0, bd = 1e9;
      cards.forEach(function (c, i) { var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid); if (d < bd) { bd = d; best = i; } });
      if (best === last) return;
      last = best;
      cards.forEach(function (c, i) { c.classList.toggle('is-on', i === best); });
      dots.forEach(function (d, i) { if (i === best) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      paint(best);
    }
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(mark); }, { passive: true });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () {
        var c = cards[i];
        track.scrollTo({ left: c.offsetLeft - (track.clientWidth - c.offsetWidth) / 2, behavior: 'smooth' });
      });
    });
    cards.forEach(function (c, i) {
      c.addEventListener('click', function () { if (i !== last) dots[i].click(); });
    });
    window.addEventListener('resize', function () { last = -1; mark(); });
    mark();
  }
  function init() { document.querySelectorAll('[data-pd]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloup-plans-mapa"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var pins = Array.prototype.slice.call(root.querySelectorAll('[data-pm-pin]'));
    var cards = root.querySelectorAll('[data-pm-card]');
    var walker = root.querySelector('[data-pm-walker]');
    var next = root.querySelector('[data-pm-next]');
    var cur = 0, t = 0;
    function go(i) {
      if (!pins.length) return;
      i = (i + pins.length) % pins.length;
      if (i === cur) return;
      cur = i;
      pins.forEach(function (p, j) { p.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
      cards.forEach(function (c, j) { c.hidden = j !== i; });
      walker.style.setProperty('--x', pins[i].dataset.x + '%');
      walker.style.setProperty('--y', pins[i].dataset.y + '%');
      root.classList.remove('is-walking'); void root.offsetWidth; root.classList.add('is-walking');
      clearTimeout(t); t = setTimeout(function () { root.classList.remove('is-walking'); }, 900);
    }
    pins.forEach(function (p, i) { p.addEventListener('click', function () { go(i); }); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });
  }
  function init() { document.querySelectorAll('[data-pm]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloup-plans-pases"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    root.querySelectorAll('[data-pt-tk]').forEach(function (t) {
      t.addEventListener('click', function () {
        var on = t.getAttribute('aria-pressed') !== 'true';
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on && navigator.vibrate) { try { navigator.vibrate(12); } catch (e) {} }
      });
    });
  }
  function init() { document.querySelectorAll('[data-pt]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloup-plans-stickers"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var sts = root.querySelectorAll('[data-pc-st]');
    var cards = root.querySelectorAll('[data-pc-card]');
    var empty = root.querySelector('[data-pc-empty]');
    sts.forEach(function (s, i) {
      s.addEventListener('click', function () {
        var on = s.getAttribute('aria-pressed') !== 'true';
        sts.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        cards.forEach(function (c) { c.hidden = true; });
        if (on) { s.setAttribute('aria-pressed', 'true'); cards[i].hidden = false; }
        if (empty) empty.hidden = on;
      });
    });
  }
  function init() { document.querySelectorAll('[data-pc]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloup-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var pics = Array.prototype.slice.call(root.querySelectorAll('[data-blr-pic]'));
    var dlg = root.querySelector('[data-blr-box]');
    if (!pics.length || !dlg || typeof dlg.showModal !== 'function') return;
    var img = dlg.querySelector('img'), cap = dlg.querySelector('[data-blr-capbox]'), cnt = dlg.querySelector('[data-blr-count]'), idx = 0;
    function show(i) {
      idx = (i + pics.length) % pics.length;
      var b = pics[idx];
      img.src = b.dataset.src;
      img.alt = (b.querySelector('img') || {}).alt || '';
      img.style.maxWidth = Math.min(parseInt(b.dataset.w, 10) || 1200, 1200) + 'px';
      var t = b.parentNode.querySelector('[data-blr-cap]');
      cap.innerHTML = t ? t.innerHTML : '';
      cap.hidden = !cap.textContent.trim();
      cnt.textContent = (idx + 1) + ' / ' + pics.length;
    }
    function open(i) { show(i); if (!dlg.open) dlg.showModal(); }
    pics.forEach(function (b, i) { b.addEventListener('click', function () { open(i); }); });
    root.querySelectorAll('[data-blr-open]').forEach(function (q) {
      q.addEventListener('click', function () { open(parseInt(q.dataset.blrOpen, 10) || 0); });
    });
    dlg.querySelector('[data-blr-prev]').addEventListener('click', function () { show(idx - 1); });
    dlg.querySelector('[data-blr-next]').addEventListener('click', function () { show(idx + 1); });
    dlg.querySelector('[data-blr-close]').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') show(idx - 1); if (e.key === 'ArrowRight') show(idx + 1); });
    var x0 = null;
    img.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    img.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 40) show(idx + (dx < 0 ? 1 : -1)); });
    var wall = root.querySelector('.bl-wall');
    if (wall && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { wall.classList.toggle('is-off', !e.isIntersecting); }); }).observe(wall);
    }
  }
  function init() { document.querySelectorAll('[data-blr]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloup-steps"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    /* Video de YouTube: solo se carga al tocar (la página no pesa más) y se reproduce aquí mismo */
    root.querySelectorAll('[data-blu-yt]').forEach(function (b) {
      b.addEventListener('click', function () {
        var id = b.getAttribute('data-blu-yt');
        if (!/^[\w-]{6,20}$/.test(id)) return;
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&playsinline=1&rel=0&modestbranding=1';
        f.title = b.getAttribute('aria-label') || 'Video';
        f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        f.setAttribute('allowfullscreen', '');
        var box = b.closest('[data-blu-video]');
        if (box) box.classList.add('is-playing');
        b.replaceWith(f);
      });
    });
    var vbox = root.querySelector('[data-blu-video]');
    if (vbox && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { vbox.classList.toggle('is-off', !e.isIntersecting); }); }).observe(vbox);
    }
    var track = root.querySelector('[data-blu-track]');
    if (!track) return;
    var cards = Array.prototype.slice.call(track.children);
    var dots = root.querySelectorAll('[data-blu-go]');
    var fill = root.querySelector('[data-blu-fill]');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { e.target.classList.toggle('is-on', e.intersectionRatio > 0.55); });
      }, { threshold: [0, 0.55, 1] });
      cards.forEach(function (c) { io.observe(c); });
    } else { cards.forEach(function (c) { c.classList.add('is-on'); }); }
    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      var p = max > 0 ? track.scrollLeft / max : 0;
      var i = Math.round(p * (cards.length - 1));
      if (fill) fill.style.width = (p * 100) + '%';
      dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); d.classList.toggle('is-done', j < i); });
    }
    var raf;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        var c = cards[Number(d.dataset.bluGo)];
        if (c) track.scrollTo({ left: c.offsetLeft - track.offsetLeft - 20, behavior: 'smooth' });
      });
    });
    sync();
  }
  function init() { document.querySelectorAll('[data-blu]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloup-verse"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var dlg = root.querySelector('[data-bvx-dlg]');
    var body = root.querySelector('[data-bvx-body]');
    var notify = root.querySelector('[data-bvx-notify]');
    var tags = root.querySelector('[data-bvx-tags]');
    var count = root.querySelector('[data-bvx-count]');
    var picks = Array.prototype.slice.call(root.querySelectorAll('[data-bvx-open]'));
    var idx = 0;
    if (!dlg || typeof dlg.showModal !== 'function') return;
    function show(i) {
      idx = (i + picks.length) % picks.length;
      var id = picks[idx].dataset.bvxOpen;
      var tpl = root.querySelector('[data-bvx-tpl="' + id + '"]');
      body.innerHTML = '';
      body.appendChild(tpl.content.cloneNode(true));
      var locked = picks[idx].closest('.bvx-card').classList.contains('is-locked');
      if (notify) {
        notify.hidden = !locked;
        var nm = (body.querySelector('.bvx-d__name') || {}).textContent || '';
        if (tags) tags.value = 'newsletter,bloupverse,espera-' + nm.trim().toLowerCase();
      }
      if (count) count.textContent = (idx + 1) + ' / ' + picks.length;
    }
    picks.forEach(function (p, i) {
      p.addEventListener('click', function () {
        var card = p.closest('.bvx-card');
        if (card.classList.contains('is-locked')) {
          card.classList.remove('is-shake'); void card.offsetWidth; card.classList.add('is-shake');
          setTimeout(function () { show(i); dlg.showModal(); }, 380);
        } else { show(i); dlg.showModal(); }
      });
    });
    root.querySelectorAll('[data-bvx-step]').forEach(function (b) {
      b.addEventListener('click', function () { show(idx + Number(b.dataset.bvxStep)); });
    });
    root.querySelector('[data-bvx-close]').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') show(idx + 1);
      if (e.key === 'ArrowLeft') show(idx - 1);
    });
    var art = root.querySelector('[data-bvx-tilt]');
    if (art && window.matchMedia('(min-width: 990px) and (hover: hover) and (prefers-reduced-motion: no-preference)').matches) {
      var box = art.parentNode;
      box.addEventListener('mousemove', function (e) {
        var r = box.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        art.style.setProperty('--ry', (x * 14).toFixed(2) + 'deg');
        art.style.setProperty('--rx', (y * -14).toFixed(2) + 'deg');
        art.style.setProperty('--gx', ((x + .5) * 100).toFixed(1) + '%');
        art.style.setProperty('--gy', ((y + .5) * 100).toFixed(1) + '%');
      });
      box.addEventListener('mouseleave', function () { art.style.removeProperty('--rx'); art.style.removeProperty('--ry'); });
    }
    var ok = root.querySelector('[data-bvx-ok]');
    if (ok) {
      var t = document.createElement('p');
      t.className = 'bvx-toast'; t.textContent = ok.textContent;
      document.body.appendChild(t);
      setTimeout(function () { t.classList.add('is-out'); }, 4500);
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { threshold: 0.2 });
      root.querySelectorAll('.bvx-meter, .bvx-card, .bvx-star').forEach(function (el) { io.observe(el); });
    } else {
      root.querySelectorAll('.bvx-meter, .bvx-card, .bvx-star').forEach(function (el) { el.classList.add('is-in'); });
    }
  }
  function init() { document.querySelectorAll('[data-bvx]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
